export default __webpack_public_path__ + "assets/card-credit-component.ae38f63f.svg";